import { render, staticRenderFns } from "./edit-ajustement-bs.vue?vue&type=template&id=bc37dd22"
import script from "./edit-ajustement-bs.vue?vue&type=script&setup=true&lang=js"
export * from "./edit-ajustement-bs.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports